import {
  ATTENDANCE_MEETING_LABELS,
  DEFAULT_USER_TYPE_CODE,
  EMAIL_VALIDATION_REGEX,
  USER_TYPE_CODES_BY_VALUE,
  VOTE_CANDIDATES,
} from "../constants/adminConstants";

export const validateEmail = (email) => EMAIL_VALIDATION_REGEX.test(email);

export const getUserTypeCode = (typeNumeric) =>
  USER_TYPE_CODES_BY_VALUE[typeNumeric] || DEFAULT_USER_TYPE_CODE;

export const filterUsersByType = (users, type) =>
  users.filter((user) => user.type === type);

export const getEmailList = (users) =>
  users.map((user) => user.email).join("; ");

export const processVoteData = (attendance) => {
  const mostRecentVotes = Object.values(
    attendance.reduce((votesByEmail, record) => {
      if (!record.type.includes("vote")) return votesByEmail;

      const currentVote = votesByEmail[record.email];
      if (!currentVote || currentVote.dateTime < record.dateTime) {
        votesByEmail[record.email] = record;
      }
      return votesByEmail;
    }, {}),
  );

  return VOTE_CANDIDATES.reduce(
    (counts, candidate) => ({
      ...counts,
      [candidate]: mostRecentVotes.filter((vote) =>
        vote.type.includes(candidate),
      ).length,
    }),
    {},
  );
};

export const formatAdminDateTime = (dateTimeString) => {
  const date = new Date(dateTimeString);
  if (Number.isNaN(date.getTime())) return dateTimeString;

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;

  return `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;
};

export const getAttendanceMeetingLabel = (type) => {
  if (!type.includes("prevent_meet")) return type;

  const meetingKey = Object.keys(ATTENDANCE_MEETING_LABELS).find((key) =>
    type.includes(key),
  );
  return meetingKey
    ? ATTENDANCE_MEETING_LABELS[meetingKey]
    : `${type} Attendance`;
};

export const processAttendanceData = (attendance) => {
  const summary = attendance.reduce((counts, record) => {
    const meetingName = getAttendanceMeetingLabel(record.type);
    return {
      ...counts,
      [meetingName]: (counts[meetingName] || 0) + 1,
    };
  }, {});

  const data = attendance.map(({ id, name, email, type, dateTime }) => ({
    id,
    name,
    email,
    type,
    dateTime: formatAdminDateTime(dateTime),
  }));

  return { data, summary };
};
